module.exports = __webpack_public_path__ + "static/riertkiert-1-1024x1024-c5ef7a2523e9e3960a07c5c8a7909b6c.png";